import { css } from '@emotion/core';
import { blue, gray, red, teal } from '@kizen/kds/Colors';

// Kizen Colors

export const colorsButton = {
  blue: {
    hover: blue['blue-700'],
    default: blue['blue-500'],
  },
  green: {
    hover: teal['teal-500'],
    default: teal['teal-300'],
  },
  red: {
    hover: red['red-500'],
    default: red['red-300'],
  },
  lightRed: {
    hover: red['red-700'],
    default: red['red-300'],
  },
  iconGray: {
    hover: gray['gray-800'],
    default: gray['gray-600'],
  },
  // to show broken buttons in #F00
  brokenRed: {
    hover: red['red-700'],
    default: '#f00',
  },
  iconWhite: {
    hover: gray['gray-50'],
    default: gray['gray-300'],
  },
};

export const background = gray['gray-300'];

export const shadow = css`
  box-shadow: 0 18px 26px rgba(0, 0, 0, 0.06);
`;

export const shadowLight = css`
  box-shadow: 0 18px 26px rgba(0, 0, 0, 0.03);
`;

export const shadowOverlay = css`
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const border = css`
  border-width: 1px;
  border-color: ${gray['gray-500']};
  border-style: solid;
  border-radius: 8px;
`;

export const borderTight = css`
  border-width: 1px;
  border-color: ${gray['gray-500']};
  border-style: solid;
  border-radius: 4px;
`;

export const dropdownColors = {
  hover: blue['blue-100'],
};
